export { ScrollArea } from "./scroll-area"
export type { ScrollAreaProps } from "./scroll-area"
